<div class="modal-header modal-head">
    <h4 class="modal-titles" >
        Modifica massiva
    </h4>
</div>
<div class="modal-body">
    <div class="row">
        <div class="col">
            <div class="m-3">
                <ul class="list-group">
                    <ng-container *ngFor="let obj of callList; index as i">
                        <li class="list-group-item d-flex" id="row_{{obj.id}}">
                            <div class="col-8">
                                {{obj.title}}
                            </div>
                            <div class="col-4 text-end" [hidden]="!obj.loading">
                                <img alt="" class="loading" src="/assets/images/spinner/iphone-spinner-1.gif" >
                            </div>
                            <div class="col-4 text-end" [hidden]="obj.loading">
                                <i class="fas fa-check grn" [hidden]="!obj.resultSuccess"></i>
                                <i class="fas fa-times red" [hidden]="obj.resultSuccess"></i>
                            </div>
                        </li>
                    </ng-container>
                  </ul>
                
            </div>
        </div>
    </div>
    <!-- Modal footer -->
    <div class="modal-foot">
        <div class="row my-3 text-center">
            
        </div>
    </div>
</div>


    